module.exports = __webpack_public_path__ + "img/slide3.ee922ccd.jpg";